import { useColorMode } from '@vueuse/core';

export type ThemePreference = 'light' | 'dark' | 'auto';

const colorMode = useColorMode({
  storageKey: 'avp.theme.v1',
  attribute: 'class',
  selector: 'html',
  // Keep `auto` in the ref's value so UI can show a check on the user's
  // actual preference (System / Light / Dark). Without this, `.value`
  // resolves `auto` → `light`/`dark` and the picker shows the wrong row.
  emitAuto: true,
  modes: {
    light: '',
    dark: 'dark',
  },
});

export function useTheme() {
  return {
    preference: colorMode,
    setPreference(value: ThemePreference) {
      colorMode.value = value;
    },
  };
}
